import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Hook to manage print mode functionality
 * Handles print view detection, auto-printing, and tab closing after print
 */
export const usePrintMode = () => {
  const [searchParams] = useSearchParams();
  const printView = searchParams.get('view') === 'print';
  const printTemplate = searchParams.get('print_template') === 'true';

  // Auto-trigger print dialog when in print view
  useEffect(() => {
    if (!printView) return;

    const timer = setTimeout(() => {
      window.print();
    }, 100); // short delay for rendering

    return () => clearTimeout(timer);
  }, [printView]);

  // Close tab after printing
  useEffect(() => {
    if (!printView) return;

    const closeTab = () => {
      window.close();
    };

    window.addEventListener('afterprint', closeTab);
    return () => {
      window.removeEventListener('afterprint', closeTab);
    };
  }, [printView]);

  return { printView, printTemplate };
};
